import { render } from "./peligroExtincion.vue?vue&type=template&id=0a36fe01&scoped=true"
const script = {}

import "./peligroExtincion.vue?vue&type=style&index=0&id=0a36fe01&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a36fe01"]])

export default __exports__